(function (window, angular) {

	function register(appName) {

		const app = angular.module(appName);

		return {
			component  : component,
			components : components,
			directive  : directive,
			directives : directives,
			controller : controller,
			controllers: controllers,
			service    : service,
			services   : services,
			provider   : provider,
			providers  : providers,
			config     : config,
			constant   : constant,
			constants  : constants,
			factory    : factory,
			factories  : factories
		};

		function component(componentClass) {
			app.component(componentClass.META.name, new componentClass());
			return this;
		}

		function components(components) {
			components.forEach((componentClass) => {
				component(componentClass);
			});
			return this;
		}

		function directive(directiveClass) {

			let _constructorFn = normalizeConstructor(directiveClass);

			if (!_constructorFn.prototype.compile) {
				// create an empty compile function if none was defined.
				_constructorFn.prototype.compile = () => {
				};
			}

			let originalCompileFn = cloneFunction(_constructorFn.prototype.compile);

			// Decorate the compile method to automatically return the link method (if it exists)
			// and bind it to the context of the constructor (so `this` works correctly).
			// This gets around the problem of a non-lexical "this" which occurs when the directive class itself
			// returns `this.link` from within the compile function.
			override(_constructorFn.prototype, 'compile', function () {
				return function () {
					originalCompileFn.apply(this, arguments);

					if (_constructorFn.prototype.link) {
						return _constructorFn.prototype.link.bind(this);
					}
				};
			});

			let factoryArray = createFactoryArray(_constructorFn);

			app.directive(directiveClass.META.name, factoryArray);
			return this;
		}

		function directives(directives) {
			directives.forEach((directiveClass) => {
				directive(directiveClass);
			});
			return this;
		}

		function controller(controllerClass) {
			app.controller(controllerClass.META.name, controllerClass);
			return this;
		}

		function controllers(controllers) {
			controllers.forEach((controllerClass) => {
				controller(controllerClass);
			});
			return this;
		}

		function service(serviceClass) {
			app.service(serviceClass.META.name, serviceClass);
			return this;
		}

		function services(services) {
			services.forEach((serviceClass) => {
				service(serviceClass);
			});
			return this;
		}

		function provider(providerClass) {
			app.provider(providerClass.META.name, providerClass);
			return this;
		}


		function providers(providers) {
			providers.forEach((providerClass) => {
				provider(providerClass);
			});
			return this;
		}

		function config(configClass) {
			let _constructorFn = createFactoryArray(configClass);
			app.config(_constructorFn);
			return this;
		}

		function constant(constantObject) {
			app.constant(constantObject.META.name, constantObject.Constant);
			return this;
		}

		function constants(constants) {
			constants.forEach((constantObject) => {
				constant(constantObject);
			});
			return this;
		}

		function factory(factoryClass) {
			let _constructorFn = normalizeConstructor(factoryClass);
			let _factoryArray  = createFactoryArray(_constructorFn);
			app.factory(factoryClass.META.name, _factoryArray);
			return this;
		}

		function factories(factories) {
			factories.forEach((factoryClass) => {
				factory(factoryClass);
			});
			return this;
		}

		function normalizeConstructor(input) {
			let constructorFn;

			if (input.constructor === Array) {
				//
				let injected          = input.slice(0, input.length - 1);
				constructorFn         = input[input.length - 1];
				constructorFn.$inject = injected;
			} else {
				constructorFn = input;
			}

			return constructorFn;
		}

		function createFactoryArray(constructorFn) {
			// get the array of dependencies that are needed by this component (as contained in the `$inject` array)
			let args         = constructorFn.$inject || [];
			let factoryArray = args.slice(); // create a copy of the array
			// The factoryArray uses Angular's array notation whereby each element of the array is the name of a
			// dependency, and the final item is the factory function itself.
			factoryArray.push((...args) => {
				return new constructorFn(...args);
				// let instance = new constructorFn(...args);
				// for (let key in instance) {
				// 	instance[key] = instance[key];
				// }
				// return instance;
			});

			return factoryArray;
		}

		function cloneFunction(original) {
			return function () {
				return original.apply(this, arguments);
			};
		}

		function override(object, methodName, callback) {
			object[methodName] = callback(object[methodName]);
		}
	}

	angular.register = register;

})(window, window.angular);



// WEBPACK FOOTER //
// ./core/utils/register.js